import React, { useState, useEffect } from "react";
import { Box, Paper, Typography, Button, Alert } from "@mui/material";
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";
import StopCard from "./StopCard";

const RouteTimeline = ({ stops, currentStop }) => {
  const [expandedStops, setExpandedStops] = useState({});

  useEffect(() => {
    const initialExpandedState = {};
    if (stops) {
      stops.forEach((stop) => {
        // Collapse all stops by default
        initialExpandedState[stop.stopId] = false;
      });
    }
    setExpandedStops(initialExpandedState);
  }, [stops]);

  if (!stops || stops.length === 0) {
    return (
      <Paper sx={{ p: 3 }}>
        <Alert severity="info">
          No route details available for this driver at the moment.
        </Alert>
      </Paper>
    );
  }

  const handleToggle = (stopId) => {
    setExpandedStops((prev) => ({ ...prev, [stopId]: !prev[stopId] }));
  };

  const allStopsExpanded =
    Object.keys(expandedStops).length === stops.length &&
    Object.values(expandedStops).every((isExpanded) => isExpanded);

  const handleToggleAll = () => {
    const newExpandedState = !allStopsExpanded;
    const newExpandedStops = {};
    stops.forEach((stop) => {
      newExpandedStops[stop.stopId] = newExpandedState;
    });
    setExpandedStops(newExpandedStops);
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Delivery Route
        </Typography>
        {stops && stops.length > 1 && (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              size="small"
              variant="outlined"
              onClick={handleToggleAll}
              startIcon={
                allStopsExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />
              }
            >
              {allStopsExpanded ? "Collapse All" : "Expand All"}
            </Button>
          </Box>
        )}
      </Box>
      <Box sx={{ pl: 2 }}>
        {stops.map((stop, index) => (
          <StopCard
            key={stop.stopId}
            stop={stop}
            isCompleted={stop.status === "completed"}
            isCurrent={stop.status === "current" || stop.status === "en_route"}
            isNext={stop.stopNumber === currentStop + 1}
            isExpanded={!!expandedStops[stop.stopId]}
            onToggle={() => handleToggle(stop.stopId)}
          />
        ))}
      </Box>
    </Paper>
  );
};

export default RouteTimeline;
